// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3tOrY","container":"styles_container__DuM2T","title":"styles_title__1NpQU","wrapper":"styles_wrapper__2J2MG","answer":"styles_answer__2U3jG"};